import React from 'react';
const Autocomplete = ({
  placeholder,
  value,
  onChange,
  list,
  col,
  onSelect,
  browserAutoComplete,
  fullMerchantList,
  onFocus,
  onBlur,
}) => {
  return (
    <>
      <input
        list={placeholder}
        className={`form-control ${col || ''}`}
        name={placeholder}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={browserAutoComplete}
        onSelect={onSelect}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <datalist id={placeholder}>
        {fullMerchantList?.length ? (
          <>
            {fullMerchantList?.map((u, i) => (
              <option key={i} value={u?.name} label={`${u?.m_id}(${u?.id})`} />
            ))}
          </>
        ) : (
          <>
            {list.map((u, i) => (
              <option key={i} value={u} />
            ))}
          </>
        )}
      </datalist>
    </>
  );
};

export default Autocomplete;
